import LandingComponents from '../view/Landing/LandingComponents';
import PrintTicket from '../view/Landing/TicketDesignPrinting/PrintTicket';
import BookTicket from '../view/Landing/CustomerBookTicket/BookTicket';
import TicketDetail from '../view/Landing/CustomerBookTicket/TicketDetail';
import FeedbackTablet from '../view/FeedbackTablet/FeedbackTablet';
// import BookTicketV2 from '../view/Landing/CustomerBookTicketV2/BookTicketV2';

export const routes = [
  {
    primaryText: 'Landing Component',
    path: '/',
    authorized: [''],
    component: <LandingComponents />,
  },
  {
    primaryText: 'Book Ticket',
    path: '/book-your-ticket',
    authorized: [''],
    component: <BookTicket />,
  },
  // {
  //   primaryText: 'Book Ticket V2',
  //   path: '/book-your-ticket-v2',
  //   authorized: [''],
  //   component: <BookTicketV2 />,
  // },
  {
    primaryText: 'Print Ticket',
    path: '/ticket-print',
    authorized: [''],
    component: <PrintTicket />,
  },
  {
    primaryText: 'Print Ticket',
    path: '/tickets/:id',
    authorized: [''],
    component: <TicketDetail />,
  },
  {
    primaryText: 'Feedback Tablet',
    path: '/feedback-tablet',
    authorized: [''],
    component: <FeedbackTablet />,
  }
];